import React from 'react';
import { Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import {
    DoneOutline as MarkReadIcon,
    Delete as DeleteIcon,
    Link as LinkIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

/**
 * Menu contextuel pour les actions sur les notifications
 *
 * @param {Object} props - Propriétés du composant
 * @param {boolean} props.open - État d'ouverture du menu
 * @param {HTMLElement} props.anchorEl - Élément d'ancrage du menu
 * @param {Function} props.onClose - Fonction de fermeture du menu
 * @param {Object} props.notification - Notification sélectionnée
 * @param {Function} props.onMarkAsRead - Fonction pour marquer comme lu
 * @param {Function} props.onDelete - Fonction pour supprimer
 */
const NotificationMenu = ({ open, anchorEl, onClose, notification, onMarkAsRead, onDelete }) => {
    const navigate = useNavigate();

    if (!notification) {
        return null;
    }

    /**
     * Naviguer vers le lien de la notification
     */
    const handleNavigate = () => {
        if (notification.link) {
            navigate(notification.link);
            onClose();
        }
    };

    return (
        <Menu
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
        >
            {!notification.isRead && (
                <MenuItem onClick={onMarkAsRead}>
                    <ListItemIcon>
                        <MarkReadIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Marquer comme lu" />
                </MenuItem>
            )}

            {notification.link && (
                <MenuItem onClick={handleNavigate}>
                    <ListItemIcon>
                        <LinkIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Ouvrir le lien" />
                </MenuItem>
            )}

            <MenuItem onClick={onDelete}>
                <ListItemIcon>
                    <DeleteIcon fontSize="small" color="error" />
                </ListItemIcon>
                <ListItemText primary="Supprimer" />
            </MenuItem>
        </Menu>
    );
};

export default NotificationMenu;